import axios from "axios";
import { MdStayPrimaryLandscape } from "react-icons/md";


export default axios.create({
    baseURL: 'https://ma3uw6iajl.execute-api.us-east-2.amazonaws.com',
    headers: {
        Authorization : ''
    }
});



export const MTSApi = (mtsurl, json, loading, token, complete, error) => {
    loading(true);
    axios.post(
        mtsurl, 
        JSON.stringify(json), 
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        }
    ).then(response => {
        loading(false);
        complete(JSON.parse(response.data.body));
    }, error => {
        loading(false);
    });
}

export const MTSLoadData = (url,param,dispatch)=>{
    axios.post(
        url,
        JSON.stringify(param),
        {
            headers:
            {
                'Content-Type': 'application/json'
            }
        }
    ).then((response) => {
        console.log(response)
        var LoadData = JSON.parse(response.data.body);
        dispatch({
            type: "EDIT", data: {
                ...LoadData[0]
            }
        });
        },
        (err) => {
            console.log(err);
        })
    }
export const MTSGetData = async (url,param) => {
   var response = await axios.post(
        url,
        JSON.stringify(param),
        {
            headers:
            {
                'Content-Type': 'application/json'
            }
        }
    );
    var LoadData = JSON.parse(response.data.body);
            return LoadData;
}